import React from 'react';
import { Membership } from 'works/legacy/graphql/works-membership';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateMembershipStatus } from '@identity/graphql/mutations/membership';
import { Modal, Text } from '@common/components';
export default function UpdateMembershipStatusModal({
  open,
  setOpen,
  membership,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  membership: Membership | undefined;
}) {
  const [update, { loading }] = useMutation(UpdateMembershipStatus, {
    onCompleted: (ms) => {
      const active = ms.updateWorksMembershipStatus.worksMembership.active;
      createMessage(
        'success',
        `User has been ${active ? 'reactivated' : 'deactivated'}.`
      );
      setOpen(false);
    },
    onError: () => {
      createMessage(
        'error',
        'User could not be updated. Please try again or contact your hiring partner.'
      );
    },
    refetchQueries: ['WorksMembership', 'WorksMembershipsQuery'],
  });

  return (
    <Modal
      visible={open}
      onCancel={() => {
        setOpen(false);
      }}
      onOk={() => {
        update({
          variables: {
            id: membership?.id,
            active: !membership?.active || false,
          },
        });
      }}
      okText={membership?.active ? 'Deactivate User' : 'Reactivate User'}
      title={membership?.active ? 'Deactivate User' : 'Reactivate User'}
      confirmLoading={loading}
      danger={membership?.active}
    >
      <Text>
        Are you sure you want to{' '}
        {membership?.active ? 'deactivate' : 'reactivate'}{' '}
        <b>{membership?.name}</b>?
      </Text>
    </Modal>
  );
}
